/**
 * OAuth selectors
 */

import { createSelector } from 'reselect';

const selectLogin = (state) => state.get('oauth');

const makeToggleModal = () =>
  createSelector(selectLogin, (state) => state.get('modalState'));

const makeSelectLoginInfo = () =>
  createSelector(selectLogin, (oauthState) => ({
    policyNumber: oauthState.getIn(['form', 'policyNumber']),
    email: oauthState.getIn(['form', 'email']),
    name: oauthState.getIn(['form', 'name']),
    cellcaptiveId: oauthState.getIn(['form', 'cellcaptiveId']),
  }));

const makeSelectErrors = () =>
  createSelector(selectLogin, (state) => state.get('error'));
const makeSelectAuthToken = () =>
  createSelector(selectLogin, (state) => state.get('authToken'));
const makeSelectLoadingStatus = () =>
  createSelector(selectLogin, (state) => state.get('loading'));
const makeSelectPurchaseDate = () =>
  createSelector(selectLogin, (state) => state.get('FNOLPurchaseDate'));


const makeSelectVerificationCode = () =>
  createSelector(selectLogin, (oauthState) =>
    oauthState.getIn(['form', 'verificationCode'])
  );

const makeSelectRequireVerificationCode = () =>
  createSelector(selectLogin, (oauthState) =>
    oauthState.getIn(['form', 'requireVerificationCode'])
  );

export {
  makeSelectLoginInfo,
  makeToggleModal,
  makeSelectErrors,
  makeSelectAuthToken,
  makeSelectVerificationCode,
  makeSelectRequireVerificationCode,
  makeSelectLoadingStatus,
  makeSelectPurchaseDate,
};



// WEBPACK FOOTER //
// ./app/containers/Login/selectors.js